import loadGoogleMapsApi from './loadGoogleMapsApi';

export default (key: string, callback: Function) =>
	loadGoogleMapsApi({key})
		.then(() => callback());
